import { Err } from "../../../error";

export interface IScanKey {
  customerId: string;
  siteId: string;
  scanDate?: string;
}

export interface ITilesInfo {
  date: string | null;
  path: string;
}

export interface IPrescan {
  isExpired: boolean;
  doneDate: string;
  orthophotoTilesPath: string;
  elevationMapTilesPath: string;
  previousScanDetailedDemDiffTiles: ITilesInfo | null;
  penultScanDetailedDemDiffTiles: ITilesInfo | null;
  designGradeDetailedDemDiffTiles: ITilesInfo | null;
}

export interface IPrescanState {
  data: IPrescan | null;
  error: Err;
  pending: boolean;
}

export const PRESCAN_FETCH_FULFILLED = "PRESCAN_FETCH_FULFILLED";
export const putPrescanFetchFulfilled = (prescan: IPrescan) => ({
  type: PRESCAN_FETCH_FULFILLED,
  payload: prescan,
});

const defaultState: IPrescanState = {
  data: null,
  error: null,
  pending: false,
};

export default function reducer(
  state: IPrescanState = defaultState,
  action: IAction<any>,
): IPrescanState {
  switch (action.type) {
    case PRESCAN_FETCH_FULFILLED:
      return {
        ...defaultState,
        data: action.payload,
      };
    default:
      return state;
  }
} // END reducer

export const prescanHasPreviousDetailedDemDiff = (
  prescanState: IPrescanState,
): boolean =>
  !!(prescanState.data && prescanState.data.previousScanDetailedDemDiffTiles);

export const prescanHasPenultDetailedDemDiff = (
  prescanState: IPrescanState,
): boolean =>
  !!(prescanState.data && prescanState.data.penultScanDetailedDemDiffTiles);

export const prescanHasDemDiffWithDg = (prescanState: IPrescanState): boolean =>
  !!(prescanState.data && prescanState.data.designGradeDetailedDemDiffTiles);
